import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Category, Transaction, User } from '../types'
import { formatDate } from '../utils/formatting';
import { stat } from 'fs';
import { USER_LANGUAGE } from '../common/constants';
import { getBaseLanguage } from '../utils/utilities';

export interface AppState {
  isMobile: boolean;
  transactions: Transaction[];
  wholeTransactions: Transaction[];
  selectedTransaction: Transaction | null;
  // currentMonth: Date;
  currentMonth: number;
  currentDay: string;

  isLoggedIn: boolean;
  userInfo: User | null;

  category: Category | null;
  baseLanguage: USER_LANGUAGE;
}

const initialState: AppState = {
  isMobile: false,
  transactions: [],
  wholeTransactions: [],
  selectedTransaction: null,
  // currentMonth: new Date(),
  currentMonth: (new Date()).getTime(),
  currentDay: formatDate(new Date()),

  isLoggedIn: false,
  userInfo: null,

  category: null,
  baseLanguage: getBaseLanguage() as USER_LANGUAGE,
}

export const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setWholeTransaction: (state, action: PayloadAction<Transaction[]>) => {
      state.wholeTransactions = action.payload;
    },
    setTransaction: (state, action: PayloadAction<Transaction[]>) => {
      state.transactions = action.payload;
    },
    addTransaction: (state, action: PayloadAction<Transaction>) => {
      state.wholeTransactions = [...state.wholeTransactions, action.payload];
    },
    updateTransaction: (state, action: PayloadAction<Transaction>) => {
      state.wholeTransactions = [...state.wholeTransactions.map((item) =>
        item.id === action.payload.id ? {...item, ...action.payload} : item
      )];
    },
    deleteTransaction: (state, action: PayloadAction<Transaction>) => {
      state.wholeTransactions = state.wholeTransactions.filter((item) => item.id !== action.payload.id);
    },
    deleteTransactions: (state, action: PayloadAction<string[]>) => {
      state.wholeTransactions = state.wholeTransactions.filter((item) => 
        !action.payload.includes(item.id));
    },
    setIsMobile: (state, action: PayloadAction<boolean>) => {
      state.isMobile = action.payload;
    },
    setCurrentMonth: (state, action: PayloadAction<Date>) => {
      state.currentMonth = action.payload.getTime();
    },
    setCurrentDay: (state, action: PayloadAction<string>) => {
      state.currentDay = action.payload;
    },

    setSelectedTransaction: (state, action: PayloadAction<Transaction | null>) => {
      state.selectedTransaction = action.payload
    },

    setIsLoggedIn: (state, action: PayloadAction<boolean>) => {
      state.isLoggedIn = action.payload;
    },
    setUserInfo: (state, action: PayloadAction<User | null>) => {
      state.userInfo = action.payload;
    },
    setUserLanguage: (state, action: PayloadAction<string>) => {
      state.userInfo = {...state.userInfo, language: action.payload} as User;
    },
    setUserCurrency: (state, action: PayloadAction<string>) => {
      state.userInfo = {...state.userInfo, currency: action.payload} as User;
    },
    setUserId: (state, action: PayloadAction<string>) => {
      if (state.userInfo) {
        state.userInfo.id = action.payload;
      }
    },
    setCategory: (state, action: PayloadAction<Category>) => {
      state.category = action.payload;
    },
  }
})

export const {setIsMobile, setWholeTransaction, setTransaction, addTransaction, 
  updateTransaction, deleteTransaction, deleteTransactions, setSelectedTransaction, 
  setCurrentMonth, setCurrentDay, setIsLoggedIn, setUserInfo, setUserLanguage, setUserCurrency,
  setUserId,
  setCategory,
} = appSlice.actions;
export default appSlice.reducer;